module.exports = __webpack_public_path__ + "img/puzzle_bg2.6fd782b6.jpg";